<script>
  import formStateMixin from 'bootstrap-vue/esm/mixins/form-state'
  import clickoutMixin from 'bootstrap-vue/esm/mixins/click-out.js'

  export default {
    mixins: [
      formStateMixin,
      clickoutMixin
    ],
    data () {
      return {
        show: false,
        listenForClickOut: true
      }
    },
    computed: {
    },
    props: {
      placeholder: {type: String, required: true},
      searchPlaceholder: {type: String, required: true},
      optionKey: {type: String, default: '@id'},
      emptyValue: {type: String, default: '-'},
      disabled: {type: Boolean, default: false},
      clearButton: {type: Boolean, default: true},

      options: {type: Array, required: true},
      selected: {required: true},
      selectedItem: {required: true},
      searchValue: {type: String, default: ''},
    },
    methods: {
      select (value) {
        // We need to set empty model to make model watchers react to it
        this.$emit('select', value || null)
      },
      search (search) {
        if (!this.disabled) {
          this.$emit('search', search)
        }
      }
    },
    mounted () {
      this.search('')
    }
  }
</script>
<template>
  <b-input-group>
    <b-dropdown id="dropdown-text" variant="drop-down" :disabled="disabled" :class="'form-control lookup-select ' + stateClass">
      <template slot="button-content">
        <span v-if="!selectedItem">{{placeholder}}</span>
        <slot name="selected-item" v-if="selectedItem" v-bind:item="selectedItem">{{selectedItem}}</slot>
      </template>
      <b-dropdown-form>
        <b-input-group>
          <b-input-group-prepend tag="label" is-text for="search" class="sr-only">{{searchPlaceholder}}</b-input-group-prepend>
          <b-form-input
            id="search"
            ref="search"
            @input="search"
            :value="searchValue"
            :placeholder="searchPlaceholder"
          ></b-form-input>
        </b-input-group>
      </b-dropdown-form>
      <b-dropdown-divider v-if="selected"></b-dropdown-divider>
      <b-dropdown-item-button
        v-if="selectedItem"
        :key="selectedItem[optionKey]"
        :active="true"
        @click.stop.prevent="clearButton && select(null)"
      >
        <slot name="item" v-bind:item="selectedItem">{{selectedItem}}</slot>
      </b-dropdown-item-button>
      <b-dropdown-divider v-if="options"></b-dropdown-divider>
      <b-dropdown-item-button
        v-for="item in options"
        v-if="item[optionKey] !== selected"
        :key="item[optionKey]"
        @click.stop.prevent="select(item[optionKey])"
      >
        <slot name="item" v-bind:item="item">{{item}}</slot>
      </b-dropdown-item-button>
    </b-dropdown>
    <b-input-group-append v-if="clearButton">
      <b-button variant="danger" @click="select(null)" :disabled="!selectedItem"><i><span>×</span></i></b-button>
    </b-input-group-append>
  </b-input-group>
</template>
